import baseMigrate from "@Shared/Entities/AbstractEntities/BaseEntity/migrate";
const version1 = (current = {}) => {
    const { version = 0 } = current;
    if (version >= 1) {
        return current;
    }
    return { ...current, version: 1 };
};
export default (original = {}) => {
    const baseMigrated = baseMigrate(original);
    const converted = [version1].reduce((converted, f) => f(converted), original);
    const { version, instantPackageId, customerId, supplierId, customerUserId, supplierUserId, parameters, lines, contractLength, monthlyCostPerLine, monthlyDeviceCost, monthlyLinesCost, monthlyCostPerDevice, monthlyTotalCost, totalContractCost, customerService, roaming, commonCharges, simChange, packageIsLocked, scores, status, tariffWithoutPhonesPerLinePerMonth, tariffWithoutPhonesPerLinePerMonthWithVAT, tariffWithPhonesPerLinePerMonth, tariffWithPhonesPerLinePerMonthWithVAT, customerName, } = converted;
    return {
        ...baseMigrated,
        version,
        instantPackageId,
        customerId,
        supplierId,
        customerUserId,
        supplierUserId,
        parameters,
        lines,
        contractLength,
        monthlyCostPerLine,
        monthlyDeviceCost,
        monthlyLinesCost,
        monthlyCostPerDevice,
        monthlyTotalCost,
        totalContractCost,
        customerService,
        roaming,
        commonCharges,
        simChange,
        packageIsLocked,
        scores,
        status,
        tariffWithoutPhonesPerLinePerMonth,
        tariffWithoutPhonesPerLinePerMonthWithVAT,
        tariffWithPhonesPerLinePerMonth,
        tariffWithPhonesPerLinePerMonthWithVAT,
        customerName,
    };
};
